import Footer from 'components/Header/Footer'
import Header from 'components/Header/Header'
import React from 'react'
import AustraliaList from './AustraliaList'


const AustraliaUni = () => {
  return (
    <div className='main'>
        <Header/>
<AustraliaList/>
    <Footer/>
    </div>
  )
}

export default AustraliaUni